import { ExpansionPanel, NotObservedChip } from '@cibo/ui'
import { Stack, Typography, Skeleton } from '@mui/material'
import { FC } from 'react'
import { CarbonFootprintHeader } from './CarbonFootprintHeader'

export const CarbonFootprintSkeleton: FC = ({ children }) => (
  <Stack spacing={1} flex={1} p={2}>
    <ExpansionPanel
      spacing={1}
      header={<CarbonFootprintHeader />}
      collapsed={
        <Stack direction="row" spacing={3} alignItems="center">
          <Typography variant="subtitle1">2000</Typography>
          <Stack alignItems="center">
            <Skeleton>
              <NotObservedChip />
            </Skeleton>
            <Skeleton>
              <Typography variant="caption">foobar</Typography>
            </Skeleton>
          </Stack>
          <Stack>
            <Skeleton>
              <Typography variant="subtitle1">foobar</Typography>
            </Skeleton>
            <Skeleton>
              <Typography variant="caption">foobar</Typography>
            </Skeleton>
          </Stack>
        </Stack>
      }
      expanded={<></>}
      disabled={true}
    />
    {children}
  </Stack>
)
